@if (options().length > 1) {
<enr-button-group
  class="enrichment-mode-switch"
  size="small"
  ariaLabel="Enrichment view"
  data-testid="enrichment-mode-switch"
  [options]="options()"
  [value]="pageMode()"
  (valueChange)="choose($event)"
/>
}
